'use strict';

const constants = require('../constants');
const swatchSelector = require('../components/swatchSelector');

const SELECTORS = {
    plp: '.js-plp',
    plpGrid: '.js-plp__grid',
    rangeInput: '.js-range-input',
    minRangeInput: '.js-min-range',
    maxRangeInput: '.js-max-range',
    priceSlider: '.js-price-slider',
    minInput: '.js-min-input',
    maxInput: '.js-max-input',
    priceInput: '.js-price-input',
    dropdown: '.js-dropdown-item',
    sruleValue: '',
    accordionFilterText: '.js-button-accordion-filter-text'
}

const CLASS_MAP = {
    'is-new': 'isnew',
};

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
const updateDom = ($results, selector) => {
    let $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
const handleRefinements = ($results) => {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        let activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
const parseResults = (response) => {
    let $results = $(response);
    let specialHandlers = {
        '.refinements': handleRefinements
    };

    [
        '.js-filterbar-update',
        '.header-bar',
        '.header.page-title',
        '.cc-breadcrumb',
        '.js-plp-header',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.grid-header',
        '.js-button-update-count',
        '.js-keyword-update-count',
        '.js-keyword-title',
        '.js-pagination'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    $(SELECTORS.rangeInput).on('input', togglePriceRange);
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
const getContent = ($element, $target) => {
    const showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'POST',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
const updateSortOptions = (response) => {
    let $tempDom = $('<div>').append($(response));
    let sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Update the URL parameters with the selected page size value
 * 
 * @return {undefined}
 */
const updateURLParams = () => {
    const defaultPageSize = $(SELECTORS.plpGrid).data('page-size');
    let pageSize = defaultPageSize;

    if (pageSize) {
        const url = new URL(window.location.href);
        const szParam = new URLSearchParams(window.location.search).get('sz');
        const pageSizeNum = Number(pageSize);
        const defaultNum = Number(defaultPageSize);

        if (szParam) {
            const szParamNum = Number(szParam);
            pageSize = (pageSizeNum + szParamNum).toFixed();
        } else {
            pageSize = (pageSizeNum + defaultNum).toFixed();
        }

        url.searchParams.set('sz', pageSize);
        window.history.replaceState({}, '', url);
    }
}

/**
 * Update the price range values and the range slider
 * We calculate the left and right percentage based on the min and max values
 * Using the formula (value - min) / (max - min) * 100
 * @param {Event} e - event object
 */
const togglePriceRange = (e) => {
    const priceGap = 10;
    const rangevalue = $(SELECTORS.priceSlider);
    const rangeInputvalue = $(SELECTORS.rangeInput);
    const minVal = parseInt($(SELECTORS.minRangeInput).val());
    const maxVal = parseInt($(SELECTORS.maxRangeInput).val());
    const minimum = parseInt(rangeInputvalue.eq(0).attr("min"));
    const maximum = parseInt(rangeInputvalue.eq(0).attr("max"));
    const diff = maxVal - minVal;
    if (diff < priceGap) {
        if ($(e.target).hasClass("min-range")) {
            $(SELECTORS.minRangeInput).val(maxVal - priceGap);
        } else {
            $(SELECTORS.maxRangeInput).val(minVal + priceGap);
        }
    } else {
        const $minInput = $(SELECTORS.minInput);
        const $maxInput = $(SELECTORS.maxInput);
        const currency = $minInput.data("currency");
        $minInput.val(minVal + '' + currency);
        $maxInput.val(maxVal + '' + currency);
        const leftPercentage = ((minVal - minimum) / (maximum - minimum)) * 100;
        const rightPercentage = 100 - ((maxVal - minimum) / (maximum - minimum)) * 100;
        rangevalue.css("left", `${leftPercentage}%`);
        rangevalue.css("right", `${rightPercentage}%`);
    }
}

/**
 * Update accessibility attributes for the refinement bar
 * @param {boolean} open - true if the refinement bar is opening
 */
const updateAccessibilityAttrs = (open = true) => {
    if (open) {
        if (window.isMobile) {
            $('body').addClass('cc-body-no-scroll');
        }
        $('.refinement-bar').attr('aria-hidden', false);
        $('.refinement-bar').attr('tabindex', 0);
        $('button.filter-results').attr('aria-expanded', true);
    } else {
        if (window.isMobile) {
            $('body').removeClass('cc-body-no-scroll');
        }
        $('.refinement-bar').attr('aria-hidden', true);
        $('.refinement-bar').attr('tabindex', -1);
        $('button.filter-results').attr('aria-expanded', false);
    }
}

/**
 * Handles the logic for open and close the refinement bar
 * @param {boolean} open - true if the refinement bar is opening
 */
const toggleRefinements = (open = true) => {
    $('.refinement-bar').toggleClass('cc-slide-in', open);
    $('.refinement-bar').siblings().attr('aria-hidden', open);
    $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', open);
    $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', open);
    $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', open);
    if (open) {
        setTimeout(() => {
            $('.refinement-bar .close').first().trigger('focus');
        }, constants.defaultAnimationTimeout + 30);
    } else {
        $('button.filter-results').trigger('focus');
    }
    updateAccessibilityAttrs(open);
}

const refinementBar = document.querySelector('sidebar.refinement-bar');
/**
 * Handles click events on the document to close the refinement bar
 * when clicking outside of it and not on the filter trigger
 * @param {MouseEvent} event - The click event
*/
document.addEventListener('click', function (event) {
    if (!refinementBar) return;

    const isOpen = refinementBar.classList.contains('cc-slide-in');
    if (!isOpen) return;

    const clickedInsideSidebar = !!event.target.closest('sidebar.refinement-bar');

    const clickedOnFilterTrigger = !!event.target.closest(
        '.cc-button-filter, .filter-results'
    );

    if (!clickedInsideSidebar && !clickedOnFilterTrigger) {
        toggleRefinements(false);
    }
});

/**
 * Handles keydown events to close the refinement bar on ESC key press
 * @param {KeyboardEvent} event - The keydown event
 */
document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
        toggleRefinements(false);
    }
});

/**
 * Updates the filter text based on the provided srule value.
 * @param {string} sruleValue - The value of the srule parameter.
 */
const updateFilterText = (sruleValue = '') => {
    if (sruleValue && sruleValue !== '') {
        const normalizedSruleValue = CLASS_MAP[sruleValue] || sruleValue;
        const $matchedElement = $(SELECTORS.dropdown).removeClass('js-applied').filter(function() {
            return $(this).hasClass(normalizedSruleValue);
        }).addClass('js-applied');

        const buttonText = $matchedElement.text();

        $(SELECTORS.accordionFilterText).empty().text(buttonText);
    }

    if ($(SELECTORS.accordionFilterText).text() === '') {
        $(SELECTORS.accordionFilterText).text($(SELECTORS.accordionFilterText).data('text'));
    }
};

/**
 * Decrypt the encrypted seoURL 
 * @param {string} seoURL - The encrypted seoURL
 */
const decryptSEOUrl= async (seoURL = '') => {
    if (seoURL && seoURL !== '') {

        try {
            const keyBuffer = Uint8Array.from(atob(utf8ToBase64('a3f9d5b6e8c3d7f11a2b3c4d5e6f7a8b')), c => c.charCodeAt(0));
            const ivBuffer = Uint8Array.from(atob(utf8ToBase64('f7a8b2e6d0c9a4b3')), c => c.charCodeAt(0));
            const encryptedBuffer = Uint8Array.from(atob(seoURL), c => c.charCodeAt(0));

            const cryptoKey = await crypto.subtle.importKey(
                "raw",
                keyBuffer,
                { name: "AES-CBC" },
                true,
                ["decrypt"]
            );
            
            const decryptedBuffer = await crypto.subtle.decrypt(
                {
                    name: "AES-CBC",
                    iv: ivBuffer,
                },
                cryptoKey,
                encryptedBuffer
            );

            return new TextDecoder().decode(decryptedBuffer);

        } catch (error) {
            console.error("Decryption failed:", error);
            return null;
        }
    }
};

/**
 * encode a string to base64 utf8 safe
 * @param {string} str - The str to encode
 */
const utf8ToBase64= (str = '') => {
  const utf8Bytes = new TextEncoder().encode(str);
  let binaryString = '';
  utf8Bytes.forEach(byte => {
    binaryString += String.fromCharCode(byte);
  });
  return btoa(binaryString);
}

module.exports = {

    filter: () => {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', () => {
            const isOpen = $('.refinement-bar').hasClass('cc-slide-in');
            toggleRefinements(!isOpen);
        });
    },

    closeRefinements: () => {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .modal-background', (evt) => {
            toggleRefinements(false);

            if (evt.currentTarget.classList.contains('close') && window.isMobile) {
                $(window).scrollTop(0);
            }
        });

        // Close refinement bar when escape key is pressed
        $('.refinement-bar').on('keydown', (e) => {
            if (e.key === 'Escape') {
                toggleRefinements(false);
            }
        });
    },


    sort: function () {
        $('.container').on('click', SELECTORS.dropdown, function (e) {
            e.preventDefault();
            const url = this.value;
            const urlObj = new URL(url);
            SELECTORS.sruleValue = urlObj.searchParams.get('srule');
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            
            var seoUrl = $(this).data('seo-href') || searchUrl;
            if (seoUrl) {
                if ( $(this).data('isencrypted')) {
                    decryptSEOUrl(seoUrl)
                        .then(decryptedURL => {
                            // Once the Promise from decryptSEOUrl resolves,
                            // decryptedURL will contain the actual decrypted value.
                            window.history.pushState({}, null, decryptedURL);
                            console.log("History pushState updated with:", decryptedURL);
                        })
                        .catch(error => {
                            // Handle any errors during decryption
                            console.error("Error decrypting SEO URL:", error);
                            // Optionally, push the original seoUrl or a fallback if decryption fails
                            window.history.pushState({}, null, seoUrl);
                        });
                } 
                else 
                {
                    window.history.pushState({}, null, seoUrl);
                }
            }
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'POST',
                success: (response) => {
                    parseResults(response);
                    swatchSelector.initializeClass();
                    $.spinner().stop();
                    updateFilterText(SELECTORS.sruleValue);
                    window.spsDataLayer.internal.handleAditionConsent();
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: () => {
        // Show more products
        $('.container').on('click', '.show-more button', (e) => {
            e.stopPropagation();
            const $this = $(e.currentTarget);
            const showMoreUrl = $this.data('url');
            e.preventDefault();
            $.spinner().start();
            $this.trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'POST',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    swatchSelector.initializeClass();
                    updateURLParams();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .js-refinement-input, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);

                var searchUrl = $(this).data('href');

                var seoUrl = $(this).data('seo-href') || searchUrl;
                if (seoUrl) {
                    if ( $(this).data('isencrypted')) {
                       decryptSEOUrl(seoUrl)
                        .then(decryptedURL => {
                            // Once the Promise from decryptSEOUrl resolves,
                            // decryptedURL will contain the actual decrypted value.
                            window.history.pushState({}, null, decryptedURL);
                            console.log("History pushState updated with:", decryptedURL);
                        })
                        .catch(error => {
                            // Handle any errors during decryption
                            console.error("Error decrypting SEO URL:", error);
                            // Optionally, push the original seoUrl or a fallback if decryption fails
                            window.history.pushState({}, null, seoUrl);
                        });
                    } 
                    else 
                    {
                        window.history.pushState({}, null, seoUrl);
                    }
                }

                var attributeId = '#' + $(this).find('span').last().attr('id');
                $.ajax({
                    url: searchUrl,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: searchUrl
                    },
                    method: 'POST',
                    success: function (response) {
                        parseResults(response);
                        swatchSelector.initializeClass();
                        updateFilterText();
                        $.spinner().stop();
                        $(attributeId).parent('button').trigger('focus');
                        window.spsDataLayer.internal.handleAditionConsent();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').trigger('focus');
                    }
                });
            }
        );
    },

    changeLayout: function () {
        $(SELECTORS.plp).on('click', '.js-plp-layout-tile-big', function () {
            if (!$(this).hasClass('cc-active')) {
                $(this).siblings().removeClass('cc-active');
                $(this).addClass('cc-active');
                $(this).closest(SELECTORS.plp).find(SELECTORS.plpGrid).removeClass('cc-plp__grid--small').addClass('cc-plp__grid--big');
            }
        });
        $(SELECTORS.plp).on('click', '.js-plp-layout-tile-small', function () {
            if (!$(this).hasClass('cc-active')) {
                $(this).siblings().removeClass('cc-active');
                $(this).addClass('cc-active');
                $(this).closest(SELECTORS.plp).find(SELECTORS.plpGrid).removeClass('cc-plp__grid--big').addClass('cc-plp__grid--small');
            }
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    onPopState: function () {
        $(window).on('popstate', () => {
            window.location = window.location.href;
        });
    },

    sliderPrice: () => {
        $(() => {
            const rangevalue = $(SELECTORS.priceSlider);
            const rangeInputvalue = $(SELECTORS.rangeInput);

            const replaceUrlParam = (url, paramName, paramValue) => {
                if (paramValue == null) {
                    paramValue = '';
                }
                let pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
                if (url.search(pattern) >= 0) {
                    return url.replace(pattern, '$1' + paramValue + '$2');
                }
                url = url.replace(/[?#]$/, '');
                return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
            }

            $(SELECTORS.priceInput).on("input", function (e) {
                const priceGap = 10;
                let minp = parseInt($(SELECTORS.minInput).val());
                let maxp = parseInt($(SELECTORS.maxInput).val());
                let diff = maxp - minp;

                if (minp < 0) {
                    $(SELECTORS.minInput).val(0);
                    minp = 0;
                }

                if (maxp > 100000) {
                    $(SELECTORS.maxInput).val(100000);
                    maxp = 100000;
                }

                if (minp > maxp - priceGap) {
                    $(SELECTORS.minInput).val(maxp - priceGap);
                    minp = maxp - priceGap;

                    if (minp < 0) {
                        $(SELECTORS.minInput).val(0);
                        minp = 0;
                    }
                }
                if (diff >= priceGap && maxp <= parseInt(rangeInputvalue.eq(1).attr("max"))) {
                    if ($(this).hasClass("min-input")) {
                        rangeInputvalue.eq(0).val(minp);
                        rangevalue.css("left", `${(minp / parseInt(rangeInputvalue.eq(0).attr("max"))) * 100}%`);
                    } else {
                        rangeInputvalue.eq(1).val(maxp);
                        rangevalue.css("right", `${100 - (maxp / parseInt(rangeInputvalue.eq(1).attr("max"))) * 100}%`);
                    }
                }
            });

            $(SELECTORS.rangeInput).on("input", togglePriceRange);

            $('.container').on('change', SELECTORS.rangeInput, function (e) {
                e.preventDefault();
                e.stopPropagation();
                $.spinner().start();
                $(this).trigger('search:filter', e);

                var minVal = $('.min-range').val();
                var maxVal = $('.max-range').val();
                var searchUrl = $(this).data('href');
                var seoUrl = $(this).data('seo-href') || searchUrl;
                if (seoUrl) {
                    seoUrl = replaceUrlParam(seoUrl, 'pmin', parseInt(minVal) );
                    seoUrl = replaceUrlParam(seoUrl, 'pmax', parseInt(maxVal));
                    window.history.pushState({}, null, seoUrl);
                }
                var attributeId = '#' + $(this).find('span').last().attr('id');
                searchUrl = replaceUrlParam(searchUrl, 'pmin', parseInt(minVal));
                searchUrl = replaceUrlParam(searchUrl, 'pmax', parseInt(maxVal));
                $.ajax({
                    url: searchUrl,
                    data: {
                        pmin: parseInt(minVal),
                        pmax: parseInt(maxVal),
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: searchUrl
                    },
                    method: 'POST',
                    success: function (response) {
                        parseResults(response);
                        swatchSelector.initializeClass();
                        if ($(response).find('.js-close-refine-bar').length > 0) {
                            toggleRefinements(false);
                        }
                        $.spinner().stop();
                        $(attributeId).parent('button').trigger('focus');
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').trigger('focus');
                    }
                });
            });
        });
    },

    updateSelectOnLoad: () => {
        $(window).on('load', () => {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.has('srule')) {
                const sruleValue = urlParams.get('srule');
                updateFilterText(sruleValue);
            }
        });
    },

    onRefinementToggle: () => {
        $(SELECTORS.plp).on('click', '[data-toggle][data-trc]', function () {
            setTimeout(() => {
                if($(this).attr('data-target').includes('refinement')) {
                    let expanded = $(this).attr('aria-expanded');
                    let trackingIdArray = $(this).attr('data-trc').split('::');
                    trackingIdArray.pop();
                    if (expanded === 'false') {
                        trackingIdArray.push('open');
                        $(this).attr('data-trc-once','');
                    } else {
                        trackingIdArray.push('close');
                    }
                    $(this).attr('data-trc', trackingIdArray.join('::'));
                }
            },200);
        });
    }
};